export default {
    computed: {
        profile() {
            return this.$store.state.profile;
        },
        query() {
            return this.$store.state.query;
        },
    }
}